import React, {useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/upload.scss';
import closeicon from '../../images/popups/upload/closeicon.png';
import uploadimage from '../../images/popups/upload/uploadimage.png';
import greyuploadimage from '../../images/popups/upload/greyuploadimage.png';
import fileicon from '../../images/popups/upload/fileicon.png';
import getResponse from '../actions/Project';
import { useState } from 'react';
import Progress from '../Reusables/Progress';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import { useSelector } from 'react-redux';
import Snackbars from '../Reusables/Snackbar';

function Upload(props) {
    const newConnection = useSelector((state) => state.connection);
    const { id, show, handleClose, setUpload, uploadstate, setLoadEnd, loadend, setUploaderror, 
        uploaderror, created, pageType } = props;
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const [filename, setFilename] = useState(null);
    const [filesize, setFilesize] = useState(null);
    const [messagevalue, setMessage] = useState('');
    const [loadstart, setLoad] = useState(false);
    const [disbledstate, setDisbledstate] = useState(false);
    const [errormsg, setError] = useState(null);
    const [open, setOpen] = useState(null)
   
    useEffect(() => {
        setOpen(false)
        // Receiving the response
        newConnection.on("Received", function (user, message) {
            // We can assign user-supplied strings to an element's textContent because it
            // is not interpreted as markup. If you're assigning in any other way, you 
            // should be aware of possible script injection concerns.
            console.log("[SignalR] RECEIVING... ",user, message)
            if(message === 100) {
                setLoadEnd(true)
                setLoad(false);
            }
            setMessage(message);
        });
    }, [])
       
    useEffect(() => {
        setFile(null);
        setFilename(null);
        setFilesize(null);
        setMessage('');
        setLoad(false);
        setDisbledstate(false);
    },[created])

    function ShowFile(e) {
        setMessage('');
        if(pageType == "Entities" || pageType == "Contacts") {
            var extensions = ["csv"];
        } else if(pageType == "Broadcast") {
            var extensions = ["png", "jpeg", "jpg", "svg", "gif", "jfif"];
        } else {
            var extensions = ["csv", "xls", "pdf", "ppt", "docx", "txt", "png", "jpeg", "gif", "jpg", "svg", "tiff", "tif", "jfif", "xlsx", "pptx", "html", "zip"];
        }

        if(e.target.files[0].name.lastIndexOf('.') !== -1) {
            var extension = e.target.files[0].name.substring(e.target.files[0].name.lastIndexOf('.')+1, e.target.files[0].name.length);
        }
        else {
            var extension = ''
        }
        if(e.target.files[0] && ((e.target.files[0].size / (1024 ** 2)).toFixed(2)) <= 75 && extensions.includes(extension.toLowerCase()) && e.target.files[0].name.length <= 90) {
            // document.querySelector('#upload-error-message').innerHTML = '';
            setFile(e.target.files[0]);
            setFilename(e.target.files[0].name);
            setFilesize((e.target.files[0].size / (1024 ** 2)) >= 1 ? `${(e.target.files[0].size / (1024 ** 2)).toFixed(2)} MB` : `${(e.target.files[0].size / 1024).toFixed(2)} KB`);
            setLoadEnd(false);
            setDisbledstate(true);     
            setLoad(true);
            setMessage('');
            let formData = new FormData();
            if(pageType == "Entities" || pageType == "Contacts") {
                formData.set('CsvFile', e.target.files[0])
            } else if(pageType == "Entities-Files") {
                formData.set('file', e.target.files[0]);
                formData.set('entityId', id);
            } else {
                formData.set('file', e.target.files[0]);
                formData.set('projectId', id);
            }

            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                }
                else if(accesstoken === 'noToken') {
                    navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
                }
                else {
                    var endpoint = "";
                        if(pageType == "Entities") {
                            endpoint = "/api/entity/importentities";
                        } else if(pageType == "Contacts") {
                            endpoint = "/api/contacts/importcontacts";
                        } else if(pageType == "Broadcast") {
                            endpoint = "/api/Project/broadcast/uploadfile";
                        } else if(pageType == "Entities-Files") {
                            endpoint = "/api/entity/uploadfile";
                        } else {
                            endpoint = "/api/Project/uploadfile";
                        }
                        getResponse.UploadFiles(endpoint, formData, accesstoken, (response) => {  
                            if(response.status == 200) {
                                console.log("[SignalR] RECEIVING... ", response)
                                setUpload(!uploadstate); 
                                setFile(null);
                                document.getElementById("fileInput").value=null; 
                                setDisbledstate(false);
                                setOpen(false)
                                // setMessage('');
                                if(pageType == "Broadcast") {
                                    setLoad(true);
                                    setLoadEnd(false)
                                } else {
                                    setLoad(false);
                                    setLoadEnd(true)
                                }
                            } else if(response.status == 400) {
                                setError(response.data.message);
                                setOpen(true);
                                setUpload(!uploadstate); 
                                setFile(null);
                                document.getElementById("fileInput").value=null; 
                                setLoad(false);
                                setDisbledstate(false);
                                setLoadEnd(false)
                            }
                            else if(response.status == 401) {
                                navigate("/login")
                            }
                        }); 
                    }
                }
                RefreshToken((accesstoken) => CallAPI(accesstoken));
            }
        else {
            if(((e.target.files[0].size / (1024 ** 2)).toFixed(2)) > 75 && !extensions.includes(extension.toLowerCase())) {
                document.getElementById('fileInput').value = null;  
                setOpen(true);
                setError(`File size is greater than 75MB and the ${extension} filetype is not supported`);
            }  
            else if(((e.target.files[0].size / (1024 ** 2)).toFixed(2)) > 75) {
                document.getElementById('fileInput').value = null;  
                setOpen(true);
                setError("File size is greater than 75MB");
            }
            else if(!extensions.includes(extension.toLowerCase())) {
                document.getElementById('fileInput').value = null;  
                setOpen(true);
                setError(`The ${extension} filetype is not supported`);
            } else if(e.target.files[0].name.length > 90) {
                document.getElementById('fileInput').value = null;  
                setOpen(true);
                setError(`Filename is too long`);
            }
        }
    };
    return (
        <div>
            <Modal show={ show } onHide={ handleClose } >
                <Modal.Body className='upload-body'>
                    <div className='close-icon'>
                        <img src={closeicon} alt="closeicon" onClick={props.handleClose}></img>
                    </div>
                    <div className='upload-content'>
                        <h4>{(pageType == "Entities") ? 'Import Properties' : (pageType == "Broadcast" ? 'Upload Files' : (pageType == "Contacts" ? 'Import Contacts' : 'Upload Files'))}<span className='file-size'>File size maximum 75 MB</span></h4>
                        <div className='upload-container'>
                            <div className='upload-sub-container'>
                                {/* <div id='upload-error-message' className='error-message'>{uploaderror}</div> */}
                                <input disabled={disbledstate} type='file' className={disbledstate ? "file-conatiner disable" : "file-conatiner enable"} id='fileInput' name='file' onChange={(e) => ShowFile(e)}></input>
                                <img src={disbledstate ? greyuploadimage : uploadimage} className='uploadimage'></img>
                                <div className='click-drag'> 
                                    <span className={disbledstate ? "click clickgrey" : "click clickblue"}>{(pageType == "Entities" || pageType == "Contacts") ? 'Click To Import' : 'Click To Upload'}{loadend ? ' More Files' : ''}</span>
                                    <span className={disbledstate ? "drag draggrey" : "drag dragblack"}>Or Drag and Drop Your file</span>
                                </div>
                            </div>
                            {(pageType == "Entities" || pageType == "Contacts") && 
                            <div className='sample-download'> 
                                <a className='sample-text' href={pageType == "Entities" ? `${process.env.REACT_APP_CC_BASE_URL}/properties.csv` : `${process.env.REACT_APP_CC_BASE_URL}/contacts.csv`} download>
                                Download sample file
                                </a>
                            </div>}
                        </div>
                        { file &&
                            <div className='progress-container'>
                                <div className='progress-file-container'>
                                    <div className='progress-file'>
                                        <img src={fileicon} alt='fileicon'></img>
                                    </div>
                                    <div className='name-size'>
                                        <div className='file-name'>{filename}</div>
                                        <div className='file-size'>{filesize}</div>
                                    </div>
                                </div>  
                                {loadstart && 
                                    <Progress value={Number(messagevalue)} />
                                }
                            </div>
                        }
                        { loadend &&
                            ((pageType == "Entities" || pageType == "Contacts") ? <div className='success'>Imported Successfully</div> :
                            <div className='success'>Uploaded Successfully</div>)
                        }
                    </div>
                </Modal.Body>
            </Modal>
            <Snackbars error={errormsg} open={open} setOpen={setOpen}/>
        </div>
    );
}

export default Upload;